/** 已知 key 走 locale；未知／不安全訊息走通用 fallback（UX-05-B）。 */
import { formatMessage } from './formatMessage';
import { isUnsafeInternalErrorMessage, resolveSafeUserVisibleError } from './safeUserVisibleError';

const BACKEND_MESSAGE_PREFERRED_KEYS = new Set([
  'travel.grouptrip.invalid.lifecycle',
  'travel.trade.conflict',
  'travel.grouptrip.concurrent.modification',
]);

function isTranslated(key, translated) {
  return typeof translated === 'string' && translated.length > 0 && translated !== key;
}

/**
 * @param {import('../api/createClient').ApiError|Error|null|undefined} cause
 * @param {(key: string) => string} t
 * @param {string} fallbackKey
 */
export function resolveApiErrorMessage(cause, t, fallbackKey = 'travel.common.loadFailed') {
  const backendKey = cause?.raw?.key;
  if (typeof backendKey === 'string' && backendKey.length > 0) {
    const translated = t(backendKey);
    if (isTranslated(backendKey, translated)) {
      const args = cause?.raw?.args;
      if (Array.isArray(args) && args.length > 0) {
        const values = Object.fromEntries(args.map((value, index) => [String(index), value]));
        return formatMessage(translated, values);
      }
      return translated;
    }
    if (
      BACKEND_MESSAGE_PREFERRED_KEYS.has(backendKey)
      && cause?.message
      && !isUnsafeInternalErrorMessage(cause.message)
    ) {
      return cause.message;
    }
  }
  return resolveSafeUserVisibleError(cause, t, fallbackKey, {
    preferBackendMessageForKeys: BACKEND_MESSAGE_PREFERRED_KEYS,
  });
}
